import {
  GET_ECOMMERCE_BY_STYLE_REQUEST,
  GET_ECOMMERCE_BY_STYLE_SUCCESS,
  GET_ECOMMERCE_BY_STYLE_ERROR
  } from "../actions/types";
  
  export const ecommerceByStyle = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_ECOMMERCE_BY_STYLE_REQUEST:
        return {
          loading: true,
        };
      case GET_ECOMMERCE_BY_STYLE_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_ECOMMERCE_BY_STYLE_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  